"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addProfessionalLink = addProfessionalLink;
exports.createClientContact = createClientContact;
exports["default"] = void 0;
exports.deleteClientContact = deleteClientContact;
exports.getClientContact = getClientContact;
exports.getClientContacts = getClientContacts;
exports.getClientPositionSuggestions = getClientPositionSuggestions;
exports.getClientProjectCount = getClientProjectCount;
exports.getClientProjects = getClientProjects;
exports.getContactsWithoutLinkedin = getContactsWithoutLinkedin;
exports.handlePasswordReset = handlePasswordReset;
exports.searchClients = searchClients;
exports.typeaheadSearch = typeaheadSearch;
exports.updateClientContact = updateClientContact;

var _api = _interopRequireWildcard(require("./api"));

var _queryString = _interopRequireDefault(require("query-string"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function createClientContact(contactData) {
  return _api["default"].post('/api/client', contactData).then(_api.extractData)["catch"](_api.errorHandler);
}

function updateClientContact(contactId, contactData) {
  return _api["default"].put("/api/client/".concat(contactId), contactData).then(_api.extractData)["catch"](_api.errorHandler);
}

function deleteClientContact(contactId) {
  return _api["default"]["delete"]("/api/client/".concat(contactId)).then(_api.extractData)["catch"](_api.errorHandler);
}

function getClientContact(contactId) {
  return _api["default"].get('/api/client/' + contactId).then(_api.extractData)["catch"](_api.errorHandler);
}

function searchClients(data) {
  return _api["default"].post(process.env.REACT_APP_SEARCH_SERVICE_URL + '/client', _objectSpread(_objectSpread({}, data), {}, {
    country: data.country || undefined
  })).then(_api.extractData)["catch"](_api.errorHandler);
}

function getClientContacts(query) {
  var queryParams = _queryString["default"].stringify(query);

  return _api["default"].get("/api/client?".concat(queryParams)).then(_api.extractData)["catch"](_api.errorHandler);
}

function getClientProjects(contactId, page) {
  return _api["default"].get("/api/client/projects/".concat(contactId, "?limit=10&page=").concat(page)).then(_api.extractData)["catch"](_api.errorHandler);
}

function getClientProjectCount(contactId) {
  return _api["default"].get('/api/client/' + contactId + '/project-count').then(_api.extractData)["catch"](_api.errorHandler);
}

function handlePasswordReset(clientEmail) {
  return _api["default"].post('/api/forgot-password', {
    email: clientEmail
  });
}

function getClientPositionSuggestions(positionString) {
  return _api["default"].get("/api/client/positions?q=".concat(positionString)).then(_api.extractData)["catch"](_api.errorHandler);
}

function typeaheadSearch(parentAccountId, query, active) {
  var queryParams = _queryString["default"].stringify({
    parentAccountId: parentAccountId,
    q: query,
    active: active
  });

  return _api["default"].get("/api/client/typeahead-search?".concat(queryParams)).then(_api.extractData)["catch"](_api.errorHandler);
}

function getContactsWithoutLinkedin(page) {
  return _api["default"].get("/api/client/without-linkedin?page=".concat(page)).then(_api.extractData)["catch"](_api.errorHandler);
}

function addProfessionalLink(id, professionalLinkUrl) {
  return _api["default"].post("/api/client/".concat(id, "/add-professional-link"), {
    professionalLinkUrl: professionalLinkUrl
  }).then(_api.extractData)["catch"](_api.errorHandler);
}

var api = {
  createClientContact: createClientContact,
  updateClientContact: updateClientContact,
  deleteClientContact: deleteClientContact,
  getClientContact: getClientContact,
  getContactsWithoutLinkedin: getContactsWithoutLinkedin,
  getClientContacts: getClientContacts,
  searchClients: searchClients,
  getClientProjects: getClientProjects,
  getClientProjectCount: getClientProjectCount,
  handlePasswordReset: handlePasswordReset,
  getClientPositionSuggestions: getClientPositionSuggestions,
  typeaheadSearch: typeaheadSearch
};
var _default = api;
exports["default"] = _default;